import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '~components/typography';
import Label from './label';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '&$directionVertical': {
      ...theme.flex.col,
    },
  },

  label: {
    ...theme.flex.mainEnd,
    marginRight: 16,
    flexShrink: 0,
    width: 200,
    height: ({ height }) => `${height}px`,

    '$directionVertical > &': {
      ...theme.flex.mainStart,
      ...theme.flex.crossCenter,
      marginRight: 'initial',
      marginBottom: 8,
      height: 'initial',
      width: 'initial',
    },
  },

  inputWrapper: { minWidth: 400 },

  directionVertical: {},
  optional: {
    marginLeft: 12,
    display: 'flex',
    alignItems: 'center',
  },
}));

const FormField = React.forwardRef((props, ref) => {
  const {
    label,
    tooltipTitle,
    TooltipProps,
    InputLabelProps,
    inputElements,
    classes,
    direction,
    isOptional,
    optionalText,
    height,
    ...otherProps
  } = props;
  const styles = useStyles({ height });

  return (
    <div
      {...otherProps}
      className={classnames(
        styles.root,
        {
          [styles.directionVertical]: direction === 'vertical',
        },
        classes.root
      )}
      ref={ref}
    >
      <Label
        direction={direction}
        tooltipTitle={tooltipTitle}
        className={classnames(styles.label, classes.labelWrapper)}
        InputLabelProps={InputLabelProps}
        TooltipProps={TooltipProps}
      >
        {label}
      </Label>

      {inputElements && (
        <div className={classnames(styles.inputWrapper, classes.inputWrapper)}>{inputElements}</div>
      )}
      {isOptional && (
        <div className={styles.optional}>
          <Typography variant="body1" themeColor="grey99">
            {optionalText || 'Optional'}
          </Typography>
        </div>
      )}
    </div>
  );
});

FormField.propTypes = {
  label: PropTypes.node,
  tooltipTitle: PropTypes.node,
  InputLabelProps: PropTypes.object,
  TooltipProps: PropTypes.object,
  inputElements: PropTypes.node,
  classes: PropTypes.shape({
    // className applied to the root element
    root: PropTypes.string,
    // className applied to the left elements' wrapper
    labelWrapper: PropTypes.string,
    // className applied to the right elements' wrapper
    inputWrapper: PropTypes.string,
  }),
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  isOptional: PropTypes.bool,
  optionalText: PropTypes.string,
  height: PropTypes.number,
};

FormField.defaultProps = {
  label: null,
  tooltipTitle: null,
  InputLabelProps: {},
  TooltipProps: {},
  inputElements: null,
  classes: {},
  direction: 'horizontal',
  isOptional: false,
  optionalText: null,
  height: 40,
};

export default FormField;
